import * as z from "zod";

export const upsertDemoConciergeKnowledge = {
  name: "upsertDemoConciergeKnowledge" as const,
  input: z.object({
    _id: z.string().optional(),
    title: z.string(),
    content: z.string(),
  }),
  output: z.object({ _id: z.string() }),
};
